// This is exporting the fetch function as a module, intened for usage in the browser
// see ./fetch for the server variant of this

const { fetch, Request, Response, Headers, Body, FormData } = window;
export default fetch;
export { Request, Response, Headers, Body, FormData };
